import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { apiClient } from './api-client';

/**
 * Singleton do SDK do Stripe (Payment Element / F12 round 6 — checkout
 * transparente).
 *
 * A doc oficial do Stripe recomenda chamar `loadStripe` uma unica vez fora
 * do ciclo de render do componente. Aqui isso vale tambem para a busca da
 * publishable key via GET /billing/config — so acontece na primeira chamada,
 * resultado fica em cache no modulo.
 *
 * Se a chave vier vazia (dev sem Stripe configurado) ou a request falhar,
 * resolve para `null` — quem consome este helper (ver
 * pages/assinar/payment-step.tsx) precisa tratar esse caso mostrando um
 * estado de erro, em vez de deixar o Payment Element preso em loading.
 */
let stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = apiClient
      .getBillingConfig()
      .then(({ publishableKey }) => {
        if (!publishableKey) {
          console.warn(
            '[stripe-client] publishableKey vazia — Stripe não configurado neste ambiente',
          );
          return null;
        }
        return loadStripe(publishableKey);
      })
      .catch((err: unknown) => {
        console.error('[stripe-client] falha ao carregar config do Stripe', err);
        return null;
      });
  }
  return stripePromise;
}
